import { render } from "./RemoveMenuItem.vue?vue&type=template&id=e03ffef6&scoped=true"
import script from "./RemoveMenuItem.vue?vue&type=script&lang=js"
export * from "./RemoveMenuItem.vue?vue&type=script&lang=js"

import "./RemoveMenuItem.vue?vue&type=style&index=0&id=e03ffef6&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\php\\Resturant-POS-PHP-VUE-MODULE\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e03ffef6"]])

export default __exports__